import BlTextareaAv from './BlTextareaAv.vue'

BlTextareaAv.install = function(Vue) {
  Vue.component(BlTextareaAv.name, BlTextareaAv)
}

export default BlTextareaAv
